var ServicesConfiguration = /** @class */ (function () {
    function ServicesConfiguration() {
        var _this = this;
        this.translateHandler = function (text) {
            return text;
        };
        this.languageHandler = function () {
            return 'en';
        };
        this.config = function (translateMethod, languageGetter) {
            if (translateMethod === void 0) { translateMethod = null; }
            if (languageGetter === void 0) { languageGetter = null; }
            var translate = translateMethod || _this.translateHandler;
            var lang = languageGetter || _this.languageHandler;
            return {
                0: {
                    id: 0,
                    alias: 'site-general',
                    order_link: null,
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/home',
                    color: '',
                },
                1: {
                    id: 1,
                    alias: 'hosting-web',
                    alias_api: 'web',
                    alias_internal: 'web',
                    details_route_params: 'id',
                    order_link: '/commander/domaine/index.php/',
                    order_more_web_hosting_link: '/produits/?old=1#order_options_web_hosting',
                    order_more_disk_link: '/produits/?old=1#order_options_disk',
                    order_more_ip_link: '/produits/?old=1#order_options_ip',
                    offer_change_link: '/commander/hebergement/modifie.php',
                    migrate_link: '/commander/import/import_admin1.php',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/hosting.web',
                    state: 'root.products.hosting-web.item.dashboard',
                    text_all: translate('Hebergements Web'),
                    color: '#1DBAB0',
                },
                2: {
                    id: 2,
                    alias: 'dedicated',
                    alias_internal: 'dedicated',
                    details_route_params: 'id',
                    order_link: null,
                    learn_more_link: null,
                    color: '#9575CD',
                },
                3: {
                    id: 3,
                    alias: 'radio',
                    alias_internal: 'radio',
                    details_route_params: 'streamingId',
                    order_link: '/commander/radio/index.php/',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/multimedia.streaming-audio',
                    color: '#EDA12F',
                },
                4: {
                    id: 4,
                    trial: true,
                    alias: 'video',
                    alias_internal: 'video',
                    details_route_params: 'id',
                    order_link: '/commander/video/index.php/',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/multimedia.streaming-video',
                    text_all: translate('Streaming Video'),
                    color: '#FF8E62',
                },
                6: {
                    id: 6,
                    trial: true,
                    alias: 'tickets',
                    order_link: null,
                    learn_more_link: 'https://infomaniak-entertainment.ch/e-tickets-billetterie-en-ligne/',
                    text_all: translate('tickets'),
                    color: '#FF3E60',
                },
                7: {
                    id: 7,
                    trial: true,
                    alias: 'vod',
                    alias_internal: 'vod',
                    details_route_params: 'id',
                    order_link: '/commander/vod/new.php/',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/multimedia.vod-aod',
                    text_all: translate('VOD'),
                    color: '#00BBD6',
                },
                10: {
                    id: 10,
                    alias: 'housing',
                    alias_internal: 'housing',
                    details_route_params: 'id',
                    order_link: null,
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/housing',
                    color: '#78909C',
                },
                13: {
                    id: 13,
                    alias: 'infomaniak_right',
                    order_link: null,
                    learn_more_link: null,
                    color: '',
                },
                14: {
                    id: 14,
                    alias: 'domain',
                    alias_internal: 'domain',
                    details_route_params: 'id',
                    order_link: '/commander/domaine/index.php/',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/domains',
                    state: 'root.products.domain.item.dashboard',
                    text_all: translate('Domaines'),
                    color: '#7986CB',
                },
                15: {
                    id: 15,
                    alias: 'hosting-web-website',
                    state: 'root.products.hosting-web.item.sites.dashboard',
                    color: '#1DBAB0',
                },
                17: {
                    id: 17,
                    alias: 'hosting-web-mysql',
                    state: 'root.products.hosting-web.item.databases',
                    color: '#1DBAB0',
                },
                18: {
                    id: 18,
                    alias: 'backup',
                    order_link: null,
                    learn_more_link: null,
                    color: '#BFCD00',
                },
                21: {
                    id: 21,
                    alias: 'radio-tera',
                    order_link: '/commander/radio/index.php/',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/multimedia.streaming-audio',
                    color: '#74A4FF',
                },
                22: {
                    id: 22,
                    alias: 'radio-flux',
                    order_link: '/commander/radio/index.php/',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/multimedia.streaming-audio',
                    color: '#74A4FF',
                },
                23: {
                    id: 23,
                    alias: 'hosting-mail',
                    alias_internal: 'mail',
                    details_route_params: 'pack-mail-id',
                    order_link: '/commander/domaine/index.php',
                    order_more_link: '/produits/?old=1#order_options',
                    offer_change_link: '/commander/mail/modifie.php',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/hosting.mail',
                    alias_api: 'mail',
                    state: 'root.products.hosting-mail.item.dashboard',
                    enable_maintenance_informations: [
                        translate('Les adresses emails seront desactivees'),
                        translate('Il sera impossible de lire ou envoyer des mails'),
                    ],
                    disable_maintenance_informations: [
                        translate('Les adresses emails seront reactivees'),
                        translate('Il sera a nouveau possible de lire ou envoyer des mails'),
                    ],
                    text_all: translate('Service Mail'),
                    color: '#d81b60',
                },
                24: {
                    id: 24,
                    alias: 'hosting-mail-mailbox',
                    state: 'root.mailbox-settings.general',
                    color: '#d81b60',
                },
                25: {
                    id: 25,
                    alias: 'cloud',
                    alias_internal: 'cloud',
                    details_route_params: 'id',
                    alias_api: 'vps',
                    order_link: '/commander/vps/new.php/',
                    order_more_web_hosting_link: '/produits/?old=1#order_options_web_hosting',
                    order_more_disk_link: '/produits/?old=1#order_options_disk',
                    order_more_ip_link: '/produits/?old=1#order_options_ip',
                    offer_change_link: '/commander/vps/modifie.php',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/hosting.managed-cloud',
                    state: 'root.products.cloud.item.dashboard',
                    unmanaged_enable_maintenance_informations: [
                        translate('Le cloud sera mis en pause le temps de la maintenance'),
                    ],
                    text_all: translate('Serveurs Cloud'),
                    color: '#BA68C8',
                },
                26: {
                    id: 26,
                    alias: 'nas',
                    alias_internal: 'nas',
                    details_route_params: 'id',
                    order_link: '/commander/nas/new.php/',
                    order_more_link: '/produits/?old=1#order_options',
                    offer_change_link: '/commander/nas/modifie.php',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/hosting.synology',
                    state: 'root.products.nas.item.dashboard',
                    enable_maintenance_informations: [
                        translate('Le NAS ne sera plus accessible et sera coupe du reseau'),
                    ],
                    disable_maintenance_informations: [
                        translate('Le NAS sera a nouveau accessible et connecte au reseau'),
                    ],
                    text_all: translate('Synology'),
                    color: '#2F9ED4',
                },
                27: {
                    id: 27,
                    alias: 'affiliation',
                    order_link: '',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/affiliation',
                    text_all: translate('Affiliation'),
                    color: '#0098FF',
                },
                28: {
                    id: 28,
                    alias: 'accreditation',
                    order_link: null,
                    learn_more_link: 'https://infomaniak-entertainment.ch/accreditation-gestion-de-staff/',
                    color: '#8ACA41',
                },
                29: {
                    id: 29,
                    alias: 'newsletter',
                    trial: true,
                    order_link: 'https://newsletter.infomaniak.com/credits/index',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/outils-pros.newsletters',
                    color: '#488FC4',
                },
                30: {
                    id: 30,
                    alias: 'cloud-hd',
                    alias_internal: 'cloudhd',
                    details_route_params: 'id',
                    order_link: null,
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/hosting.cloudHa',
                    text_all: translate('product_cloud-hd'),
                    color: '#B92D5C',
                },
                31: {
                    id: 31,
                    alias: 'invitation',
                    alias_internal: 'invitation',
                    details_route_params: 'id',
                    trial: true,
                    trial_link: "root.products.invitation.general.create",
                    order_link: "root.products.invitation.general.credits",
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/marketing-events.invitation-entertainment',
                    text_all: translate('Evenements'),
                    color: '#C595CD',
                },
                32: {
                    id: 32,
                    alias: 'renewal-warranty',
                    order_link: null,
                    learn_more_link: null,
                    color: '',
                },
                33: {
                    id: 33,
                    alias: 'domain-privacy',
                    order_link: null,
                    learn_more_link: null,
                    color: '#15B1A5',
                },
                34: {
                    id: 34,
                    alias: 'certificate',
                    alias_api: 'certificate',
                    alias_internal: 'certificate',
                    details_route_params: 'id',
                    order_link: 'root.products.certificate.general.order',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/hosting.certificates-ssl',
                    state: 'root.products.certificate.item.dashboard',
                    text_all: translate('Certificats SSL'),
                    color: '#46CB85',
                },
                35: {
                    id: 35,
                    trial: false,
                    alias: 'jelastic',
                    alias_api: 'jelastic',
                    alias_internal: 'jelastic',
                    details_route_params: 'id',
                    order_link: null,
                    beta: false,
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/jelastic',
                    state: 'root.products.jelastic.general.order',
                    color: '#2C76E8',
                },
                37: {
                    id: 37,
                    trial: true,
                    alias: 'swiss-backup',
                    alias_internal: 'swissbackup',
                    details_route_params: 'productId',
                    order_link: 'root.products.swiss-backup.general.order',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/outils-pros.swiss-backup',
                    state: 'root.products.swiss-backup.item.dashboard',
                    enable_maintenance_informations: [
                        translate('Les emplacements seront desactives'),
                    ],
                    disable_maintenance_informations: [
                        translate('Les emplacements seront reactives'),
                    ],
                    text_all: translate('Swiss backup'),
                    color: '#3B4E66',
                },
                38: {
                    id: 38,
                    alias: 'dns-anycast',
                    order_link: null,
                    learn_more_link: null,
                    color: '',
                },
                40: {
                    id: 40,
                    beta: false,
                    trial: true,
                    alias: 'drive',
                    alias_internal: 'drive',
                    order_link: 'https://shop.infomaniak.com/order/drive',
                    learn_more_link: 'https://www.infomaniak.ch/kdrive',
                    color: '#5C89F7',
                },
                43: {
                    id: 43,
                    beta: false,
                    trial: false,
                    alias: 'custom-url',
                    order_link: 'https://shop.infomaniak.com/order/url',
                    learn_more_link: '',
                    color: '#0098FF',
                },
                44: {
                    id: 44,
                    beta: false,
                    trial: false,
                    alias: 'free_mail',
                    order_link: null,
                    learn_more_link: '',
                    color: '',
                },
                48: {
                    id: 48,
                    beta: false,
                    trial: false,
                    alias: 'infomaniak-site',
                    alias_internal: 'website-builder',
                    details_route_params: 'productId',
                    order_link: null,
                    learn_more_link: '',
                    state: 'root.products.hosting-web.item.sites',
                    color: '#35BCA6',
                },
                50: {
                    id: 50,
                    beta: false,
                    trial: false,
                    alias: 'public-cloud',
                    alias_internal: 'public-clouds',
                    details_route_params: 'public-cloud-id',
                    order_link: null,
                    learn_more_link: '',
                    color: '#275F86',
                },
                51: {
                    id: 51,
                    beta: false,
                    trial: false,
                    alias: 'renewalwarranty',
                    order_link: null,
                    learn_more_link: '',
                    color: '',
                },
                52: {
                    id: 52,
                    beta: false,
                    trial: false,
                    alias: 'ksuite',
                    alias_internal: 'ksuite',
                    order_link: null,
                    learn_more_link: '',
                    color: '#9d66e1',
                },
                54: {
                    id: 54,
                    beta: false,
                    trial: false,
                    alias: 'kchat',
                    alias_internal: 'kChat',
                    order_link: null,
                    learn_more_link: '',
                    color: '#0088B2',
                },
                55: {
                    id: 55,
                    beta: false,
                    trial: false,
                    alias: 'support-premium',
                    order_link: null,
                    learn_more_link: '',
                    color: '#0098FF',
                },
                58: {
                    id: 58,
                    beta: false,
                    trial: false,
                    alias: 'llm-api',
                    order_link: 'https://shop.infomaniak.com/order/llm',
                    learn_more_link: 'http://www.infomaniak.ch/goto/' + lang() + '/hosting.llm-api',
                    color: '#8D4AFF',
                },
            };
        };
    }
    ServicesConfiguration.prototype.getServiceByAlias = function (alias) {
        var _a;
        if (alias === 'site-creator') {
            return this.config()[48];
        }
        else if (alias === 'ksuite') {
            return this.config()[43];
        }
        return (_a = Object.values(this.config()).find(function (service) { return (service === null || service === void 0 ? void 0 : service.alias) === alias; })) !== null && _a !== void 0 ? _a : null;
    };
    return ServicesConfiguration;
}());
var servicesConfiguration = new ServicesConfiguration();
export default servicesConfiguration;
